import './afbeelding-slider.scss';
import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import 'swiper/css';

document.addEventListener( 'DOMContentLoaded', function() {

	const sliders = document.querySelectorAll( '.o-afbeeldingSlider .js-imageSliderBlock' );

	sliders.forEach( function( slider ) {
		
		const slideCount = slider.querySelectorAll( '.swiper-slide' ).length;
		
		// Only initialize if there are multiple slides
		if ( slideCount <= 1 ) {
			return;
		}

		// Find navigation buttons in the parent container
		const parent = slider.closest( '.o-afbeeldingSlider__inner' );
		const nextEl = parent ? parent.querySelector( '.swiper-button-next' ) : null;
		const prevEl = parent ? parent.querySelector( '.swiper-button-prev' ) : null;

		// Initialize Swiper with loop enabled
		new Swiper( slider, {
			modules: [ Navigation ],
			slidesPerView: 1,
			spaceBetween: 0,
			loop: true,
			grabCursor: true,
			allowTouchMove: true,
			navigation: nextEl && prevEl ? {
				nextEl: nextEl,
				prevEl: prevEl,
			} : false,
		} );

	} );

} );